import { useRef, useCallback } from "react";
import setRef from "../../mixins/set-ref";
export default (function (ref) {
    var innerRef = useRef();
    var forwardRef = useCallback(function (node) {
        innerRef.current = node;
        setRef(ref, node);
    }, []);
    return [innerRef, forwardRef];
});
